import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Row, Workbook as wb, Worksheet} from "exceljs";
import {HorasExtrasTurnosService} from "../../services/horas-extra-turnos.service";
import {ModificacionMarcionesService} from "../../services/modificacion-marcaciones.service";
import {VerificacionTalentoHumanoService} from "../../services/verificacion-talento-humano.service";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {forkJoin, Subscription} from "rxjs";
import {saveAs} from 'file-saver';
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {CheckboxRenderer} from "../../../../shared/components/lfsa-checkbox/lfsa-checkbox.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {DecimalPipe} from "@angular/common";

@Component({
  selector: 'app-verificacion-talento-humano-recursos-humanos-calculado',
  templateUrl: './verificacion-talento-humano-recursos-humanos-calculado.component.html',
  styleUrls: ['./verificacion-talento-humano-recursos-humanos-calculado.component.css']
})
export class VerificacionTalentoHumanoRecursosHumanosCalculadoComponent implements OnInit {


  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  cmbYears: any[] = [];
  cmbWeeks: any[] = [];

  workbook: wb;
  data: any = [];
  reportData: any[];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  mont = true;
  week = false;
  @ViewChild('fileInput') fileInput: ElementRef;


  cmbDepartment: any[] = [];
  cmbEmployees: any[] = [];
  subscription1$: Subscription;

  constructor(
    private fb: FormBuilder,
    private _horasExtrasTurnos: HorasExtrasTurnosService,
    private _modificacionMarcaciones: ModificacionMarcionesService,
    private _verificacionTalentoHumanoService: VerificacionTalentoHumanoService,
    private _util: UtilsService,
    private numberFormatter: DecimalPipe
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.horasExtrasVerificacionTalentoHumano;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.calculateCombos();
    this.calculateCombos2();
    this.formulario = this.fb.group({
      year: ['', [Validators.required]],
      week: ['', [Validators.required]],
      department: ['', Validators.required],
      id: ['', []],
      startDate: ['', []],
      endDate: ['', []],
    });
    this.uploadForm = this.fb.group({
      excel: [''],
    });
    this.girdComponent();
    this.selectCurrentDate();
  }

  calculateCombos2() {
    this.loading = true;
    const _getAllEmployees = this._modificacionMarcaciones.getAllEmployees();
    const _getAllDepartment = this._modificacionMarcaciones.getAllDepartment();
    forkJoin([_getAllEmployees, _getAllDepartment]).subscribe((res: any) => {
      res[0].map(employe => {
        employe.id = employe.cedula;
        employe.descripcion = employe.cedula + ' | ' + employe.nombres;
      });
      res[1].map(department => {
        department.id = department.codigo;
      });
      this.cmbEmployees = res[0];
      this.cmbDepartment = res[1];
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbEmployees = [];
      this.cmbDepartment = [];
    });
  }

  formatoHorasNumeroToHorasFecha(data): string {
    const horas = Math.trunc(data);
    const minutosDecimal = (data - Math.trunc(data)) * 60;
    const onlyMinutos = Math.trunc(minutosDecimal);
    const segundosDecimal = (minutosDecimal - Math.trunc(minutosDecimal)) * 60;
    const onlySegundos = Math.trunc(segundosDecimal);
    const newFormatData = (horas < 10 ? '0' + horas : horas) + ':' + (onlyMinutos < 10 ? '0' + onlyMinutos : onlyMinutos) + ':' + (onlySegundos < 10 ? '0' + onlySegundos : onlySegundos);
    return newFormatData;
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getMondayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? -6 : 1);
    const monday = new Date(day.setDate(first));
    return monday;
  }

  getSundayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? 0 : 7);
    const sunday = new Date(day.setDate(first));
    return sunday;
  }

  addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

  formatoFecha(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
  }

  calculateWeeks(year, today?) {
    this.cmbWeeks = [];
    let firtsDateOfActualYear = new Date('01/01/' + year);
    let lastDateOfActualYear = new Date('12/31/' + year);
    for (let weeks = 1; firtsDateOfActualYear <= lastDateOfActualYear; weeks++) {
      let monday = this.getMondayOfCurrentWeek(firtsDateOfActualYear);
      let sunday = this.getSundayOfCurrentWeek(firtsDateOfActualYear);
      const payload = {
        id: weeks,
        descripcion: 'Semana ' + (weeks < 10 ? '0' + weeks : weeks) + ':   ' + this.formatoFecha(monday) + ' - ' + this.formatoFecha(sunday),
      };
      if (today && this.validateDate(firtsDateOfActualYear, today)) {
        this.actualWeek = weeks;
      }
      this.cmbWeeks.push(payload);
      firtsDateOfActualYear = this.addDays(firtsDateOfActualYear, 7);
    }
  }

  changeYear() {
    if (this.formulario.get('year').value && this.week) {
      this.calculateWeeks(this.formulario.get('year').value);
    }
  }

  validateDate(firtDateF, secondDateF) {
    let firtDate = this.getMondayOfCurrentWeek(firtDateF);
    let secondDate = this.getMondayOfCurrentWeek(secondDateF);
    if ((firtDate.getDate() === secondDate.getDate()) && (firtDate.getFullYear() === secondDate.getFullYear()) && (firtDate.getMonth() === secondDate.getMonth())) {
      return true;
    } else {
      return false;
    }
  }

  calculateCombos() {
    const date = new Date();
    let year = date.getFullYear();
    if (this.week) {
      this.calculateWeeks(year, date);
    } else {
      this.cmbWeeks = [
        {
          id: 1,
          descripcion: 'Enero'
        },
        {
          id: 2,
          descripcion: 'Febrero'
        },
        {
          id: 3,
          descripcion: 'Marzo'
        },
        {
          id: 4,
          descripcion: 'Abril'
        },
        {
          id: 5,
          descripcion: 'Mayo'
        },
        {
          id: 6,
          descripcion: 'Junio'
        },
        {
          id: 7,
          descripcion: 'Julio'
        },
        {
          id: 8,
          descripcion: 'Agosto'
        },
        {
          id: 9,
          descripcion: 'Septiembre'
        },
        {
          id: 10,
          descripcion: 'Octubre'
        },
        {
          id: 11,
          descripcion: 'Noviembre'
        },
        {
          id: 12,
          descripcion: 'Diciembre'
        },
      ];
    }
    this.cmbYears = [
      {
        id: year - 1,
        descripcion: year - 1
      },
      {
        id: year,
        descripcion: year
      },
      {
        id: year + 1,
        descripcion: year + 1
      }
    ];
  }

  selectCurrentDate() {
    const date = new Date();
    let year = date.getFullYear();
    this.formulario.get('year').setValue(year);
    this.formulario.get('week').setValue(date.getMonth() + 1);
    //this.listAll();
  }

  getAllHorasExtra() {
    this.loading = true;
    const payload = {
      year: this.formulario.get('year').value,
      number: this.formulario.get('week').value,
      type: this.week && !this.mont ? 'Semana' : 'Mes',
      department: this.formulario.get('department').value,
    };
    this.subscription1$ = this._verificacionTalentoHumanoService.getAllCalculateRRHH(payload).subscribe((res: any) => {
      res.map(data => {
        data.statusP = data.statusPrimeraAutorizacion && data.statusPrimeraAutorizacion !== 'NA' ? 'APROBADO' : 'SIN APROBAR';
        data.check = (data.statusPrimeraAutorizacion && data.statusPrimeraAutorizacion !== 'NA') ? true : false;
        data.newhorasExtrasTrabajadas = this.formatoHorasNumeroToHorasFecha(data.horasExtrasTrabajadas);
        data.newisIgnorado = data.isIgnorado ? 'INCORRECTO' : 'CORRECTO';
        data.newhorasTrabajadas = this.formatoHorasNumeroToHorasFecha(data.horasTrabajadas);
        data.newpercent_25 = this.formatoHorasNumeroToHorasFecha(data.percent_25);
        data.newpercent_50 = this.formatoHorasNumeroToHorasFecha(data.percent_50);
        data.newpercent_100 = this.formatoHorasNumeroToHorasFecha(data.percent_100);
      });
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      checkboxRenderer: CheckboxRenderer
    };

    this.columnDefs = [
      {
        headerName: 'CEDULA',
        field: 'cedula',
        sortable: true,
        filter: true,
        width: 120
      },
      {
        headerName: 'NOMBRE',
        field: 'nombre',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'FECHA',
        field: 'fecha',
        sortable: true,
        filter: true,
        width: 120
      },
      {
        headerName: 'RECARGO NOC',
        field: 'newpercent_25',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'SUPLEMENTARIAS',
        field: 'newpercent_50',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'EXTRAORDINARIAS',
        field: 'newpercent_100',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'TOTAL H-EXTRA',
        field: 'newhorasExtrasTrabajadas',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'TOTAL H',
        field: 'newhorasTrabajadas',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ESTATUS PRIM',
        field: 'statusP',
        sortable: true,
        filter: true,
        width: 200
      },
    ];
    this.rowSelection = 'single';
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  listAll() {
    if (this.formulario.valid) {
      this.subscription1$ && this.subscription1$.unsubscribe();
      this.getAllHorasExtra();
    }
  }

  descargarExcel() {
    this.generarEcxel();
  }


  async generarEcxel() {
    this.dataExcel = [];
    this.workbook = new wb();
    this.rowData.forEach(x => {
      let payload = {
        cedula: x.cedula,
        nombre: x.nombre,
        fecha: x.fecha,
        marcacionIngreso: x.marcacion?.ingreso,
        marcacionSalida: x.marcacion?.salida,
        horasTrabajadas: x.newhorasTrabajadas,
        marcacionIngresoBreak: x.marcacion?.ingresoDelBreak,
        marcacionSalidaBreak: x.marcacion?.salidaAlBreak,
        turnoIngreso: x.turno?.horaInicio,
        turnoSalida: x.turno?.horaFin,
        rangoNocturno: x.newpercent_25,
        suplementaria: x.newpercent_50,
        extraordinario: x.newpercent_100,
        horasExtrasTrabajadas: x.newhorasExtrasTrabajadas,
      };
      this.dataExcel.push(payload);
    });
    this.fillExcelMarketplace();
    await this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'reporte-semana' + '.xlsx');
    });
  }

  fillExcelMarketplace() {
    const nameSheet = 'Talento Humano';
    let header;

    header = [
      'Cédula colaborador',
      'Colaborador',
      'Fecha',
      'Entrada Marca',
      'Salida Marca',
      'Horas Trabajadas',
      'Entrada Break',
      'Salida Break',
      'Entrada Turno',
      'Salida Turno',
      'Rango Nocturno',
      'Suplementaria',
      'Extraordinaria',
      'Horas extra Trabajadas',
    ];
    let row;
    let headerRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left: 0.3149606,
          right: 0.3149606,
          top: 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    row = worksheet.getRow(0);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;

    worksheet.columns[0].width = 15;
    worksheet.columns[1].width = 40;
    worksheet.columns[2].width = 15;
    worksheet.columns[3].width = 20;
    worksheet.columns[4].width = 20;
    worksheet.columns[5].width = 15;

    worksheet.columns[6].width = 20;
    worksheet.columns[7].width = 20;

    worksheet.columns[8].width = 15;
    worksheet.columns[9].width = 15;
    worksheet.columns[10].width = 15;
    worksheet.columns[11].width = 15;
    worksheet.columns[12].width = 15;
    worksheet.columns[13].width = 15;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      });
    });

    this.data = this.formatData();

    this.fillRows(worksheet);

    this.formatWorksheet(worksheet, headerRow);
  }

  fillRows(worksheet: Worksheet) {
    for (const x1 of this.data) {
      const x2 = Object.keys(x1);
      const temp = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }
  }

  formatWorksheet(worksheet: Worksheet, headerRow: Row) {
    worksheet.eachRow(function (Rowt, rowNum) {
      Rowt.eachCell(function (cell, cellNum) {
        if (rowNum === headerRow.number) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '1aa798'},
            bgColor: {argb: 'FF0000FF'},
          };
          cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'},
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            bold: true,
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    });
  }

  formatData(n?: any) {
    this.data = [];
    switch (true) {
      default: {
        this.data = this.dataExcel;
        break;
      }
    }

    return this.data;
  }


  onFileSelect(event) {
    this.loading = true;
    let allowedExtensions = /(.xlsx)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.uploadForm.get('excel').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "xlsx" (EXCEL) ', true, 9000);
        this.fileInput.nativeElement.value = '';
        this.loading = false;
      } else {
        this.uploadForm.get('excel').setValue(file);
        const formData = new FormData();
        formData.append('file', this.uploadForm.get('excel').value);
        const payload = this.formulario.value;
        this._horasExtrasTurnos.loadShifts(payload, formData).subscribe(response => {
          this.listAll();
        });
      }
    }
  }

  cargarAprobacion() {
    this.loading = true;
    const payload = [];
    this.rowData.forEach(data => {
      /*      if(data.check && !data.id){
              payload.push(data);
            }*/
      if (data.check) {
        payload.push(data);
      }
    });
    this._verificacionTalentoHumanoService.procesarHorasExtras(payload).subscribe((res: any) => {
      this.loading = false;
      this.listAll();
    }, () => {
      this.loading = false;
      this.listAll();
    });
  }

  revision(event) {
    if (event === 'week') {
      this.week = true;
      this.mont = false;
    } else if (event === 'mont') {
      this.week = false;
      this.mont = true;
    }
    this.calculateCombos();
    this.formulario = this.fb.group({
      year: ['', [Validators.required]],
      week: ['', [Validators.required]],
      department: ['', Validators.required],
      id: ['', []],
      startDate: ['', []],
      endDate: ['', []],
    });
    this.rowData = [];
  }

  getAllHorasExtraReport() {
    this.loading = true;
    const payload = {
      year: this.formulario.get('year').value,
      number: this.formulario.get('week').value,
      type: this.week && !this.mont ? 'Semana' : 'Mes',
      department: this.formulario.get('department').value
    };
    this._verificacionTalentoHumanoService.getAllReport(payload).subscribe((res: any) => {
      res.map(data => {
        data.statusP = data.statusPrimeraAutorizacion && data.statusPrimeraAutorizacion !== 'NA' ? 'APROBADO' : 'SIN APROBAR';
        data.check = (data.statusPrimeraAutorizacion && data.statusPrimeraAutorizacion !== 'NA') ? true : false;
        data.newisIgnorado = data.isIgnorado ? 'INCORRECTO' : 'CORRECTO';
        data.newhorasExtrasTrabajadas = this.formatoHorasNumeroToHorasFecha(data.horasExtrasTrabajadas);
        data.newhorasTrabajadas = this.formatoHorasNumeroToHorasFecha(data.horasTrabajadas);
        data.newpercent_25 = this.formatoHorasNumeroToHorasFecha(data.percent_25);
        data.newpercent_50 = this.formatoHorasNumeroToHorasFecha(data.percent_50);
        data.newpercent_100 = this.formatoHorasNumeroToHorasFecha(data.percent_100);
      });
      this.reportData = res;
      this.generarEcxelReport();
      this.loading = false;
    }, () => {
      this.loading = false;
      this.reportData = [];
    });
  }

  async generarEcxelReport() {
    this.dataExcel = [];
    this.workbook = new wb();
    this.reportData.forEach(x => {
      let payload = {
        cedula: x.cedula,
        nombre: x.nombre,
        cargo: x.cargo,
        departamento: x.departamento,
        subarea: x.subarea,
        seccion: x.seccion,
        localidad: x.localidad,
        centroCosto: x.centroCosto,
        fecha: x.fecha,
        marcacionIngreso: x.marcacion?.ingreso,
        marcacionSalida: x.marcacion?.salida,
        marcacionTotal: x.marcacion?.horasTrabajas,
        marcacionIngresoBreak: x.marcacion?.ingresoDelBreak,
        marcacionSalidaBreak: x.marcacion?.salidaAlBreak,
        turnoIngreso: x.turno?.horaInicio,
        turnoSalida: x.turno?.horaFin,
        rangoNocturno: x.newpercent_25,
        suplementaria: x.newpercent_50,
        extraordinario: x.newpercent_100,
        horasExtrasTrabajadas: x.newhorasExtrasTrabajadas,
        newisIgnorado: x.newisIgnorado
      };
      this.dataExcel.push(payload);
    });
    this.fillExcelMarketplace2();
    await this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'reporte-turno_vs_marcacion' + '.xlsx');
    });
  }

  fillExcelMarketplace2() {
    const nameSheet = 'Talento Humano';
    let header;
    let header2;

    header = [
      'Cédula colaborador',
      'Colaborador',
      'Cargo',
      'Departamento',
      'SubArea',
      'Seccion',
      'Localidad',
      'Centro Costo',
      'Fecha',
      'Marcacion',
      'Turno',
      'KOSMOS HHEE',
    ];

    header2 = [
      'M Entrada',
      'M Salida',
      'M Total',
      'M Break Entrada',
      'M Break Salida',
      'T Entrada',
      'T Salida',
      'H. 25%',
      'H. 50%',
      'H. 100%',
      'Total Calculado',
      'ESTATUS',
    ];

    let row;
    let headerRow;
    let headerRow2;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left: 0.3149606,
          right: 0.3149606,
          top: 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    worksheet.mergeCells('A1:A2');
    worksheet.mergeCells('B1:B2');
    worksheet.mergeCells('C1:C2');
    worksheet.mergeCells('D1:D2');
    worksheet.mergeCells('E1:E2');
    worksheet.mergeCells('F1:F2');
    worksheet.mergeCells('G1:G2');
    
    worksheet.mergeCells('H1:H2');
    worksheet.mergeCells('I1:I2');
    
    worksheet.mergeCells('J1:N1');
    worksheet.mergeCells('O1:P1');
    worksheet.mergeCells('Q1:T1');
    worksheet.mergeCells('U1:U2');

    headerRow = worksheet.getRow(1);
    headerRow.getCell('A').value = header[0];
    headerRow.getCell('B').value = header[1];
    headerRow.getCell('C').value = header[2];
    headerRow.getCell('D').value = header[3];
    headerRow.getCell('E').value = header[4];
    headerRow.getCell('F').value = header[5];
    headerRow.getCell('G').value = header[6];
    headerRow.getCell('H').value = header[7];
    headerRow.getCell('I').value = header[8];
    headerRow.getCell('J').value = header[9];
    headerRow.getCell('O').value = header[10];
    headerRow.getCell('Q').value = header[11];

    headerRow2 = worksheet.getRow(2);
    headerRow2.getCell('J').value = header2[0];
    headerRow2.getCell('K').value = header2[1];
    headerRow2.getCell('L').value = header2[2];
    headerRow2.getCell('M').value = header2[3];
    headerRow2.getCell('N').value = header2[4];
    headerRow2.getCell('O').value = header2[5];
    headerRow2.getCell('P').value = header2[6];
    headerRow2.getCell('Q').value = header2[7];
    headerRow2.getCell('R').value = header2[8];
    headerRow2.getCell('S').value = header2[9];
    headerRow2.getCell('T').value = header2[10];
    headerRow2.getCell('U').value = header2[11];

    headerRow2.getCell('J').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };
    headerRow2.getCell('K').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };
    headerRow2.getCell('L').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };
    headerRow2.getCell('M').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };
    headerRow2.getCell('N').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };

    headerRow2.getCell('O').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };

    headerRow2.getCell('P').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };

    headerRow2.getCell('Q').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };

    headerRow2.getCell('R').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };
    headerRow2.getCell('S').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };
    headerRow2.getCell('T').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'D9D9D9'},
      bgColor: {argb: 'FF0000FF'},
    };


    headerRow2.getCell('H').font = {
      bold: true,
    };
    headerRow2.getCell('I').font = {
      bold: true,
    };
    headerRow2.getCell('J').font = {
      bold: true,
    };
    headerRow2.getCell('K').font = {
      bold: true,
    };
    headerRow2.getCell('L').font = {
      bold: true,
    };
    headerRow2.getCell('M').font = {
      bold: true,
    };
    headerRow2.getCell('N').font = {
      bold: true,
    };
    headerRow2.getCell('O').font = {
      bold: true,
    };
    headerRow2.getCell('P').font = {
      bold: true,
    };
    headerRow2.getCell('Q').font = {
      bold: true,
    };
    headerRow2.getCell('R').font = {
      bold: true,
    };


    headerRow.height = 25;

    worksheet.columns[0].width = 15;
    worksheet.columns[1].width = 40;
    worksheet.columns[2].width = 20;
    worksheet.columns[3].width = 20;
    worksheet.columns[4].width = 20;
    worksheet.columns[5].width = 30;
    worksheet.columns[6].width = 20;
    worksheet.columns[7].width = 20;
    worksheet.columns[8].width = 20;
    worksheet.columns[9].width = 15;
    worksheet.columns[10].width = 20;
    worksheet.columns[11].width = 20;
    worksheet.columns[12].width = 15;
    worksheet.columns[13].width = 15;
    worksheet.columns[14].width = 15;
    worksheet.columns[15].width = 10;
    worksheet.columns[16].width = 10;
    worksheet.columns[17].width = 10;
    worksheet.columns[18].width = 15;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      });
    });

    this.data = this.formatData();

    this.fillRows(worksheet);

    this.formatWorksheet(worksheet, headerRow);
    //this.formatWorksheet2(worksheet, headerRow2);
  }
}
